import React, { useEffect, useCallback, useMemo, useState } from "react";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as BackIcon } from "../../assets/svgs/back-square.svg";
import { Button } from "antd";
import { ReactComponent as FilterIcon } from "../../assets/svgs/filter-icon.svg";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { Tables } from "../../components/Elements/Tables/Tables";
import { ReactComponent as EyeIcon } from "../../assets/svgs/eye-icon.svg";
import SupportFilter from "./SupportFilter/SupportFilter";
import { useNavigate } from "react-router-dom";
import { Badge } from "../../components/Elements/TextStyles/Badge";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
import dayjs from "dayjs";

const Support = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  const navigate = useNavigate();
  const [status, setStatus] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tickets, setTickets] = useState([]);
  const pageSize = 10;

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Ticket ID", key: "ticketId" },
      { label: "Customer Name", key: "customername" },
      { label: "Contact Number", key: "contactNo" },
      { label: "Created On", key: "createdOn" },
      { label: "Status", key: "status" },
      { label: "Action", key: "action" },
    ],
    []
  );
  const fetchTableData = useCallback(
    async (page = 1, status) => {
      try {
        setLoading(true);
        console.log("checkedItems", status);
        const response = await getApi({
          apiUrl: API_URLS.ALL_TICKETS(page, pageSize, status, searchTerm),
        });

        console.log("Fetched tickets:", response);
        if (response.success) {
          const pageData = response.data.tickets.map((item, index) => ({
            key: item._id,
            serial: index + 1,
            ticketId: (
              <div
                style={{
                  textAlign: "center",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  maxWidth: "200px",
                }}
              >
                {item._id}
              </div>
            ),
            customername: item.customer_name,
            contactNo: item.contact_no || "-",
            status: (
                <Badge text={item.status} />
            ),
            createdOn: dayjs(item.createdAt).format("DD/MM/YYYY"),
            action: (
              <EyeIcon
                style={{
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "#06513D",
                }}
                onClick={() => navigate(`/support-ticket/chat/${item._id}`)}
              />
            ),
          }));

          setTickets(pageData);
          setTotal(response.data.pagination?.totalDocs || 0);
        } else {
          setTickets([]);
          setTotal(0);
        }
      } catch (error) {
        console.error("Error fetching static pages:", error);
        setTickets([]);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    },
    [searchTerm, navigate]
  );
  useEffect(() => {
    fetchTableData(pageNo, status);
  }, [pageNo, status, searchTerm]);

  const filteredData = useMemo(() => {
    let data = [...tickets];

    // if (sortBy && sortOrder) {
    //   data = SortData({ data, key: sortBy, order: sortOrder });
    // }

    return data;
  }, [tickets]);

  return (
    <div style={{ backgroundColor: "#fff" }} className="h-full px-5 pb-5 ">
      <div className="flex justify-end text-xs font-light p-3">
        <p>Home</p>
        <span>/</span>
        <TextStyles color="gradient">Support</TextStyles>
      </div>
      <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold px-2">
        {/* <BackIcon onClick={() => navigate(-1)} className="cursor-pointer" /> */}
        <div>Support</div>
      </div>
      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
        }}
      >
        <div className="flex justify-between mx-8">
          <div className="  flex items-center gap-5 mb-4">
            <div
              style={{
                background: "#B6D4D933",
                height: "40px",
              }}
              className="px- border border-gray-300 rounded-md text-gray-400 text-base font-light"
            >
              <p
                style={{
                  fontFamily: "Calibri",
                  fontWeight: "300",
                  fontSize: "16px",
                  lineHeight: "24px",
                  letterSpacing: "0%",
                }}
                className="pt-2 px-2"
              >
                TOTAL TICKETS {total}
              </p>
            </div>
            <SearchBar width="300px" onSearch={(value)=>{setSearchTerm(value); setPageNo(1)}} />
          </div>
          <div className="flex gap-5">
            <Button
              style={{ background: "#B6D4D9", border: "solid 1px #06513D" }}
              className="text-[12px] text-[#06513D] font-light px-4 py-5 bg-[#E6EDEB] hover:!bg-[#F8F8F8] hover:!text-[#06513D]"
              onClick={() => setFilterOpen(true)}
            >
              <FilterIcon /> FILTER
            </Button>
          </div>
        </div>
        <Tables
          headers={headers}
          data={filteredData}
          pageSize={pageSize}
          current={pageNo}
          total={total}
          loading={loading}
          onChange={(page) => setPageNo(page)}
          // sortBy={sortBy}
          // sortOrder={sortOrder}
          // onSort={handleSort}
        />
      </div>
      {filterOpen && (
        <SupportFilter
          onOpen={filterOpen}
          onClose={() => setFilterOpen(false)}
          setStatus={setStatus}
          selectedStatus={status}
        />
      )}
    </div>
  );
};

export default Support;
